module.exports = __webpack_public_path__ + "static/band-ds-f9c9d2611204fef48ed2b7b8a45872d2.png";